var map = {
	"./config.svg": 1210,
	"./data.svg": 1211,
	"./devices.svg": 1212,
	"./hosting.svg": 1213,
	"./notifications.svg": 1214,
	"./predictions.svg": 1215,
	"./privacy.svg": 1216,
	"./projects.svg": 1217,
	"./search.svg": 1218,
	"./settings.svg": 1219,
	"./sharing.svg": 1220,
	"./storage.svg": 1221,
	"./users.svg": 1222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1209;